import { createFileRoute, Outlet, redirect, useLocation, useNavigate } from '@tanstack/react-router'

import ParentHeader from '@/components/parent-header'
import { useAuthStore } from '@/store/auth.store'

export const Route = createFileRoute('/parent/_auth')({
  // component: ParentLayout,
  loader: () => {
    throw redirect({ to: '/' })
  },
})

export function ParentLayout() {
  const auth = useAuthStore()
  const navigate = useNavigate()
  const location = useLocation()

  if (!auth.isAuthenticated) {
    void navigate({
      to: '/login',
      search: {
        from: location.pathname,
      },
    })
    return
  }

  return (
    <>
      <ParentHeader />
      <Outlet />
    </>
  )
}
